import React, { ReactNode } from 'react';
import { useNotNullableContext, useShareUrls } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { ShareContextProvider } from '../../context/ShareContext';
import { PageMetaContext } from '../../context';

interface CampaignCreationSuccessShareProps {
  children: ReactNode;
}

export function CampaignCreationSuccessShareProvider({
  children,
}: CampaignCreationSuccessShareProps) {
  const { t } = useTranslation('common', { useSuspense: false });
  const { currentUrl } = useNotNullableContext(PageMetaContext);

  const emailMapper = (url: string) => {
    const shareMessage = t(
      'campaign.inviteMessage.message',
      'You can help The Demo Charity raise money for this great cause by donating directly to their campaign page - ',
    );

    return {
      subject: t(
        'campaign.inviteMessage.subject',
        'Please help support our fundraising campaign on JustGiving',
      ),
      body: `${t(
        'common.greeting',
        'Hello',
      )},\n\n${shareMessage}\n\n${url}\n\n`,
    };
  };

  const twitterMapper = () => t('common.shareMessageFallback');

  const shareItems = useShareUrls(
    {
      email: emailMapper,
      twitter: twitterMapper,
    },
    `${currentUrl}?invite=true`,
  );

  return (
    <ShareContextProvider value={{ shareItems }}>
      {children}
    </ShareContextProvider>
  );
}
